import axios_req from '../axios'
import store from '../store'

let Achecksendmobliecode = (data) => axios_req('post', '/api/login/checksendmobliecode', data, 3)
let Alogin = (data) => axios_req('post', '/api/login/login', data, 3)
let AqrCodeCreateTmpTicket = (data) => axios_req('post', `/wx/jsapi/${store.state.loginWxAppId}/qrCodeCreateTmpTicket`, data, 3)
let Aaccountbinding = (data) => axios_req('post', '/api/login/accountbinding', data, 3)
let Agetmeta = (data) => axios_req('post', '/api/meta/getmeta', data, 3)
let Arefreshlogin = (data) => axios_req('post', '/api/login/refreshlogin', data, 3)
let Aexitlogin = (data) => axios_req('post', '/api/login/exit', data, 3)
let AsearchComp = (data) => axios_req('post', '/api/entity/searchComp', data, 3)
let Auserinfo = (data) => axios_req('put', '/api/user/info', data, 3)
let Aadvertisement = (data) => axios_req('post', '/home/advertisement', data, 3)
let Ainsertrecords = (data) => axios_req('post', '/api/user/insertrecords', data, 3)
let AcreateJsapiSignature = (data) => axios_req('post', '/wx/jsapi/wx93f12cd83e68833d/createJsapiSignature', data, 3)


export  {
  Achecksendmobliecode, Alogin, AqrCodeCreateTmpTicket, Aaccountbinding, Agetmeta, 
  Arefreshlogin, AsearchComp, Aexitlogin, Auserinfo, Aadvertisement, Ainsertrecords,
  AcreateJsapiSignature
}